import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { getIn } from 'formik'

import AdFileUpload from '../../../../../../../../ReusableFormFields/AdFileUpload'

import { useMediaUpload } from '../../../../../../../../ReusableFormFields/AdFileUpload/hooks/useMediaUpload'

import { formatVideoMediaFile } from '../../../../formatters'
import { multipleFilesUpload } from '../../../../../../../../../modules/actions/files'
import { getMultipleMediaUploadsValues } from '../../../../../../../../ReusableFormFields/AdFileUpload/helpers'

import {
  MEDIA_FILE_UPLOAD,
  FILE_NAME,
  AD_FILE,
  FILE_URL
} from '../../../../../../../../ReusableFormFields/AdFileUpload/fields'
import { getGamVideoAdValidationSchema } from '../../../../validation'
import { initialGamFileValues, UPLOADED_MEDIA_LIST } from '../../../../fields'

import useStyles from './styles'

function GamVideoMediaUpload({ formik, itemPath, onMediaRemove, index, adSizes }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { setFieldValue, values } = formik

  const { fileURLKey, fileTypeKey, uploadedMediaTypeKey, mediaFile, mediaMissingError, handleMediaRemove } =
    useMediaUpload({
      formik,
      itemPath,
      onMediaRemove,
      initialMediaFileValues: initialGamFileValues,
      errorFieldName: FILE_URL
    })

  const handleMultipleMediasStartUpload = useCallback(
    (files, newMediaItemsValues) => {
      const currentMediasValues = getIn(values, UPLOADED_MEDIA_LIST)

      // this component is shown by initial media item values which added to formik values
      // once new file or files are uploaded this values should be updated with the first file in "files" array
      const updatedMediasValues = getMultipleMediaUploadsValues({
        files,
        newMediaItemsValues,
        currentMediasValues,
        index,
        initialFileValues: initialGamFileValues,
        formatMediaFile: formatVideoMediaFile
      })

      setFieldValue(UPLOADED_MEDIA_LIST, updatedMediasValues)

      // upload multiple files to server
      dispatch(multipleFilesUpload(files, { isPrivate: false }))
    },
    [values, index, setFieldValue, dispatch]
  )

  const handleMediaUploaded = useCallback(
    uploadedFile => {
      const assetFileFields = {
        ...mediaFile,
        [FILE_URL]: uploadedFile.url
      }
      setFieldValue(itemPath, assetFileFields)
    },
    [itemPath, setFieldValue, mediaFile]
  )

  const videoAdValidationSchema = useMemo(() => getGamVideoAdValidationSchema(adSizes), [adSizes])

  return (
    <div className={classes.fileContainer}>
      <AdFileUpload
        values={formik.values}
        fileValidationSchema={videoAdValidationSchema}
        onFileStartUpload={handleMultipleMediasStartUpload}
        onFileUploaded={handleMediaUploaded}
        onFileRemove={handleMediaRemove}
        error={mediaMissingError}
        mediaType={MEDIA_FILE_UPLOAD}
        fileKey={`${itemPath}[${AD_FILE}]`}
        fileNameKey={`${itemPath}[${FILE_NAME}]`}
        fileURLKey={fileURLKey}
        uploadedMediaTypeKey={uploadedMediaTypeKey}
        fileTypeKey={fileTypeKey}
        // todo update:
        accept="image/png,image/jpg,image/jpeg,image/gif"
        multiple={true}
        isDraggable={true}
      />
    </div>
  )
}

GamVideoMediaUpload.propTypes = {
  formik: PropTypes.object.isRequired,
  itemPath: PropTypes.string.isRequired,
  onMediaRemove: PropTypes.func,
  index: PropTypes.number.isRequired,
  adSizes: PropTypes.array.isRequired
}

export default GamVideoMediaUpload
